<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags   @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"  style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"   style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
                        <el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

        <el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight"   size="small" >
			<el-table-column type="index" label="序号"   min-width="60"></el-table-column>
			<!-- <el-table-column prop="Date" label="MN"  ></el-table-column> -->
            <el-table-column prop="name" label="点位名称"   sortable></el-table-column>
            <el-table-column prop="starttime" label="开始数据时间"   sortable> </el-table-column>
            <el-table-column prop="newtime" label="最新数据时间"  ></el-table-column>
            <el-table-column prop="allday" label="计划存储时间（天）"  ></el-table-column>
            <el-table-column prop="haveday" label="已存储时间（天）"  > </el-table-column>
		</el-table>
    </section>
</template>

<script>
    import {getProjects,getDevicesByProjectId,getLongDataList} from '../../api/api';
    import {in_array} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
		components: { myButton },
        data() {
            return {
                filters: {
                    mn: '',
                    projectId:''
                },
                projects:[],
                devices:[],
                dataList:[],
                listLoading:false,
                firstFlag:true,
                formHeight:0,
				type:0,
                deviceMap:new Map()
            }
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					
				}
			},
              //获取选中设备可监测的因子
              getFactorsByMn(){
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.deviceId);
                    });
                }
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
                getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType
                };

				this.dataList=[
					{ name:"观海路（百信妇科医院）",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"蓬莱开发区管委",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"牟平区环境监控中心",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"崇文街（清洋街道办事处）",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"鱼鸟河公园",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"通世南路（1861创意产业园）",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"烟台市生态环境局芝罘分局",starttime:"2022-10-26 09:37:00",newtime:"2023-05-12 14:42:00",allday:"2922",haveday:"198" },
					{ name:"芝罘区政府",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"胜利油田疗养院",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"烟台中特养生物饲料有限公司",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"养马岛",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"长江路（业达城发集团）",starttime:"2022-10-26 09:37:00",newtime:"2023-06-12 14:42:00",allday:"2922",haveday:"229" },
					{ name:"开发区环境监控中心",starttime:"2022-10-26 09:37:00",newtime:"2023-06-11 14:42:00",allday:"2922",haveday:"228" }
				]
				return;
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    this.devices = res.data.data;
                    this.filters.mn=[];
                    if( this.devices.length>0){
                        this.filters.mn.push(res.data.data[0].mnCode);

                        this.devices.forEach(element => {
                            this.deviceMap.set(element.mnCode,element);
                        });
                    }
                    this.getDataList();
				});
            },
           
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)
            this.type=sessionStorage.getItem("type");
            this.getProjects();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>



// WEBPACK FOOTER //
// Storage.vue?187f568c